import { PopulationTable } from './PopulationTable';
import { X } from 'lucide-react';

interface PopulationSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PopulationSheet({ open, onOpenChange }: PopulationSheetProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/30" onClick={() => onOpenChange(false)} />
      {/* Sheet */}
      <div className="relative bg-background shadow-lg h-full w-full sm:w-[100vw] md:w-[33vw] max-w-lg ml-auto flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-semibold">Aggregates</h2>
          <button onClick={() => onOpenChange(false)} aria-label="Close" className="p-1 rounded hover:bg-muted">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <PopulationTable />
        </div>
      </div>
    </div>
  );
} 